import request from '@/utils/request'
// import qs from 'qs'
//分页获取
import { serviceUrl } from '../config/net.config'
// const token="eyJhbGciOiJIUzUxMiJ9.eyJpZCI6IjEiLCJ1c2VyaWQiOiJzeXNhZG1pbiIsInVzZXJuYW1lIjoic3lzYWRtaW4iLCJzdWIiOiJzeXNhZG1pbiIsImV4cCI6MTY2NjA2NDc1MH0.9qFM2gT3gkm55FR6WeFTS0bfBmMGAI9BXhnHKuy3YnVJaBe72yimFaU5MgvnNDX2p5GNd-NU4xv_nNg65v1f5g"
// const token=sessionStorage.getItem('xzztcToken');

export function searchDepart() {
    return request({
        url: '/api/base/organization/getOrgByPID?pid=2B171FC37A2045E484D41EDCC109DCFB' ,
        method: 'get',
        // token
      })
}
export function byorgidgetuserinfo(recepdepcode,likeusername) {
    return request({
        url: serviceUrl+'/api/wtbu/schoolhistmuseumappointment/byorgidgetuserinfo?recepdepcode='+recepdepcode+"&likeusername="+likeusername,
        method: 'get',
        token:sessionStorage.getItem('xzztcToken')
      })
}
//保存月度总结
export function save(data){
  return request({
    url:serviceUrl+'/api/wtbu/schoolhistmuseumappointment/',
    head: 'application/json;charset=UTF-8',
    method:'post',
    data,
    token:sessionStorage.getItem('xzztcToken')
  })
}
export function byidgedetail(id) {
  return request({
      url: serviceUrl+'/api/wtbu/schoolhistmuseumappointment/'+ id ,
      method: 'get',
      token:sessionStorage.getItem('xzztcToken')
    })
}
export function schoolupdateHandleState(data) {
  return request({
      url: serviceUrl+'/api/wtbu/schoolhistmuseumappointment/updateHandleState' ,
      head: 'application/json;charset=UTF-8',
      method: 'post',
      data,
      token:sessionStorage.getItem('xzztcToken')
    })
}